import { render, staticRenderFns } from "./PhosphorIcon.vue.js?vue&type=template&id=d9cbd586!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PhosphorIcon.vue?vue&type=template&id=d9cbd586"
import script from "./PhosphorIcon.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PhosphorIcon.vue?vue&type=script&lang=js"
export * from "./PhosphorIcon.vue.js?vue&type=script&lang=js!=!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PhosphorIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports